// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","481":"4687b3c3","740":"4a55d13b"}[chunkId] + ".css";
};